import { useSettingsStore } from '../store/settingsStore';

export type Locale = 'fr-QC' | 'en-CA' | 'en-US' | 'en-GB';

export const translations = {
  'fr-QC': {
    // General / Sidebar
    appName: 'PlowPath',
    navLiveOps: 'Carte des opérations',
    navCustomers: 'Clients',
    navDrivers: 'Chauffeurs',
    navStorms: 'Tempêtes',
    navRoutes: 'Trajets',
    navFinance: 'Finances & Panneaux',
    navAnalytics: 'Rapports & KPIs',
    navSettings: 'Configuration',
    logout: 'Se déconnecter',
    operationsConsole: 'Console d\'opération',
    telemetryActive: 'Télémétrie en direct active',
    telemetryConnecting: 'Connexion au flux en cours...',
    version: 'PlowPath v3.0',
    cancel: 'Annuler',
    error: 'Erreur',
    success: 'Succès',
    loading: 'Chargement...',

    // Login Page
    phoneOrEmail: 'Téléphone ou courriel',
    password: 'Mot de passe',
    forgotPasswordLink: 'Mot de passe oublié?',
    loginBtn: 'Accéder au tableau de bord',
    establishingSession: 'Connexion en cours...',
    forgotHeaderTitle: 'Mot de passe oublié',
    forgotHeaderDesc: 'Rentre ton numéro de cell ou ton courriel pour recevoir un code à 6 chiffres.',
    requestCode: 'Demander un code de réinitialisation',
    sendingCode: 'Envoi en cours...',
    backToLogin: 'Retour à la connexion',
    codeSentAlert: 'Si le compte existe, un code de vérification à 6 chiffres a été envoyé.',
    verificationCodeLabel: 'Code de vérification à 6 chiffres',
    newPasswordLabel: 'Nouveau mot de passe',
    confirmNewPasswordLabel: 'Confirmer le nouveau mot de passe',
    establishNewPassword: 'Modifier le mot de passe',
    resettingPassword: 'Réinitialisation...',
    authorizedOnly: 'Personnel autorisé seulement',
    hidePassword: 'Masquer le mot de passe',
    showPassword: 'Afficher le mot de passe',
    min6Chars: 'Min. 6 caractères',

    // Settings Page
    systemConfigCenter: 'Centre de configuration système',
    systemConfigDesc: 'Ajuste les seuils de tempête, les gabarits SMS, les heures de silence et les limites de géolocalisation',
    tabOrgProfile: 'Profil de l\'entreprise',
    tabMyAccount: 'Mon compte',
    tabPricingRates: 'Tarification et facturation',
    tabAlertTemplates: 'Modèles d\'alertes & Silence',
    tabGeocoding: 'Zone de géocodage',
    companyProfileSettings: 'Profil de l\'entreprise',
    companyProfileDesc: 'Configure l\'image de marque et les limites opérationnelles',
    companyName: 'Nom de la compagnie',
    accumulationThreshold: 'Seuil d\'accumulation pour répartition (pouces)',
    supportPhone: 'Téléphone de soutien centralisé',
    supportEmail: 'Courriel de soutien centralisé',
    saveCompanyProfile: 'Sauvegarder le profil',
    personalAccountDetails: 'Détails du compte personnel',
    personalAccountDesc: 'Gère tes identifiants, courriel de contact et accès de sécurité',
    yourName: 'Ton nom complet',
    operationalAccessRole: 'Rôle d\'accès opérationnel',
    emailAddress: 'Adresse de courriel',
    phoneNumber: 'Numéro de téléphone',
    updateDetails: 'Mettre à jour mes détails',
    resetPasswordHeader: 'Modifier le mot de passe',
    resetPasswordDesc: 'Mets à jour tes identifiants d\'accès pour garder le système sécuritaire',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    changePasswordBtn: 'Changer le mot de passe',
    updatingPassword: 'Mise à jour en cours...',
    billingRatesHeader: 'Tarification & Estimations financières',
    billingRatesDesc: 'Personnalise les prix par défaut, le coût de l\'essence et la marge d\'overhead pour les rapports financiers',
    residentialRate: 'Tarif déneigement résidentiel ($ par arrêt)',
    commercialRate: 'Tarif déneigement commercial ($ par arrêt)',
    fuelCost: 'Coût du carburant ($ par gallon)',
    fuelEconomy: 'Consommation du camion (MPG)',
    overheadAllocation: 'Allocation des frais généraux (%)',
    saveBillingRates: 'Enregistrer les tarifs',
    alertTemplatesHeader: 'Modèles de messages texte & Silence',
    alertTemplatesDesc: 'Personnalise les SMS envoyés aux clients lors des opérations de déneigement',
    saveAlertTemplates: 'Enregistrer les modèles de message',
    languageLabel: 'Langue d\'affichage',
    languageDesc: 'Sélectionne ta langue d\'affichage préférée pour la console',
    back: 'Retour',
    phoneOrEmailRequired: 'Le téléphone ou le courriel est requis',
    passwordRequired: 'Le mot de passe est requis',
    passwordMismatch: 'Le mot de passe de confirmation ne correspond pas au nouveau mot de passe',
    passwordUpdatedSuccess: 'Mot de passe mis à jour avec succès! Connecte-toi avec ton nouveau mot de passe.',
    failedToSendCode: 'Échec de l\'envoi du code de vérification',
    failedToResetPassword: 'Échec de la réinitialisation du mot de passe',
    loginFailed: 'Échec de la connexion',
    
    // Settings Page Added
    geocodingBoundsHeader: 'Limites de géocodage',
    geocodingBoundsDesc: 'Restreindre les recherches d\'adresse Nominatim au comté ou à l\'état local pour éviter les conflits',
    geocodingBoundsExplanation: 'La saisie de limites verrouille les requêtes de recherche Nominatim aux coordonnées de délimitation spécifiées. Les adresses trouvées en dehors seront filtrées.',
    minLatLabel: 'Latitude minimale (Limite Sud)',
    maxLatLabel: 'Latitude maximale (Limite Nord)',
    minLonLabel: 'Longitude minimale (Limite Ouest)',
    maxLonLabel: 'Longitude maximale (Limite Est)',
    saveGeocodingBounds: 'Sauvegarder les limites',
    savingBounds: 'Sauvegarde des limites...',
    
    preStormHeader: '1. Modèle d\'alerte pré-tempête',
    enRouteHeader: '2. Modèle d\'alerte en route',
    completedHeader: '3. Modèle d\'alerte de complétion',
    overdueEmailHeader: '4. Modèle de courriel de facture en souffrance',
    overdueEmailDesc: 'Crée un avis de courriel HTML réactif pour alerter les clients ayant des soldes en souffrance. Les balises seront remplacées dynamiquement.',
    injectTagsLabel: 'Injecter les balises :',
    livePreviewLabel: 'Aperçu en direct du courriel',
    expandPreviewBtn: 'Agrandir l\'aperçu',
    collapsePreviewBtn: 'Réduire l\'aperçu',
    quietHoursBufferHeader: 'Heures de silence des messages',
    quietHoursBufferDesc: 'Lorsque activé, tous les SMS pré-tempête et de complétion générés durant cette période sont mis en attente et envoyés à la fin des heures de silence.',
    quietHoursStartLabel: 'Début de la période de silence',
    quietHoursEndLabel: 'Fin de la période de silence',
    saveAlertsBtn: 'Enregistrer les alertes',
    savingAlerts: 'Enregistrement...',

    failedToLoadSettings: 'Échec du chargement des paramètres',
    orgSettingsUpdated: 'Paramètres de l\'organisation mis à jour avec succès',
    failedToSaveSettings: 'Échec de la sauvegarde des paramètres',
    profileUpdated: 'Profil mis à jour avec succès',
    failedToUpdateProfile: 'Échec de la mise à jour du profil',
    passwordUpdated: 'Mot de passe mis à jour avec succès',
    passwordUpdateFailed: 'Échec de la mise à jour du mot de passe',
  },
  'en-CA': {
    // General / Sidebar
    appName: 'PlowPath',
    navLiveOps: 'Live Ops Map',
    navCustomers: 'Customers',
    navDrivers: 'Drivers',
    navStorms: 'Storms',
    navRoutes: 'Routes',
    navFinance: 'Finance & Signs',
    navAnalytics: 'Business Intelligence',
    navSettings: 'Settings',
    logout: 'Sign Out',
    operationsConsole: 'Operations Console',
    telemetryActive: 'Live Telemetry Active',
    telemetryConnecting: 'Connecting Stream...',
    version: 'PlowPath v3.0',
    cancel: 'Cancel',
    error: 'Error',
    success: 'Success',
    loading: 'Loading...',

    // Login Page
    phoneOrEmail: 'Phone or Email',
    password: 'Password',
    forgotPasswordLink: 'Forgot password?',
    loginBtn: 'Access Dashboard',
    establishingSession: 'Establishing Session...',
    forgotHeaderTitle: 'Forgot Password',
    forgotHeaderDesc: 'Enter your phone number or email and we\'ll send you a 6-digit recovery code.',
    requestCode: 'Request Reset Code',
    sendingCode: 'Sending reset code...',
    backToLogin: 'Back to Login',
    codeSentAlert: 'If an active account exists, a 6-digit verification code has been dispatched.',
    verificationCodeLabel: '6-Digit Verification Code',
    newPasswordLabel: 'New Password',
    confirmNewPasswordLabel: 'Confirm New Password',
    establishNewPassword: 'Establish New Password',
    resettingPassword: 'Resetting password...',
    authorizedOnly: 'Authorized Personnel Only',
    hidePassword: 'Hide password',
    showPassword: 'Show password',
    min6Chars: 'Min. 6 chars',

    // Settings Page
    systemConfigCenter: 'System Configuration Center',
    systemConfigDesc: 'Fine-tune system thresholds, SMS templates, quiet hours, and regional limits',
    tabOrgProfile: 'Company Profile',
    tabMyAccount: 'My Account',
    tabPricingRates: 'Financial Billing Rates',
    tabAlertTemplates: 'Alert Layouts & Quiet Hours',
    tabGeocoding: 'Geocoding Bounding Boxes',
    companyProfileSettings: 'Company Profile Settings',
    companyProfileDesc: 'Define system branding and centralized operational limits',
    companyName: 'Company Name',
    accumulationThreshold: 'Accumulation Dispatch Trigger (Inches)',
    supportPhone: 'Centralized Support Phone',
    supportEmail: 'Centralized Support Email',
    saveCompanyProfile: 'Save Company Profile',
    personalAccountDetails: 'Personal Account Roster Details',
    personalAccountDesc: 'Manage your personal credentials, support contact, and access roles',
    yourName: 'Your Name',
    operationalAccessRole: 'Operational Access Role',
    emailAddress: 'Email Address',
    phoneNumber: 'Phone Number',
    updateDetails: 'Update Details',
    resetPasswordHeader: 'Reset Operational Password',
    resetPasswordDesc: 'Securely rotate your access credentials to prevent unauthorized account logins',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    changePasswordBtn: 'Change Password',
    updatingPassword: 'Updating...',
    billingRatesHeader: 'Financial Billing Rates & Estimates',
    billingRatesDesc: 'Customize default customer pricing, fuel parameters, and overhead ratios to run automatic storm calculations',
    residentialRate: 'Residential Plow Rate ($ per Stop)',
    commercialRate: 'Commercial Plow Rate ($ per Stop)',
    fuelCost: 'Fuel Cost ($ per Gallon)',
    fuelEconomy: 'Truck Fuel Economy (MPG)',
    overheadAllocation: 'Overhead Allocation (%)',
    saveBillingRates: 'Save Billing Rates',
    alertTemplatesHeader: 'Dispatch SMS Templates & Quiet Hours',
    alertTemplatesDesc: 'Customize default text copy sent to customers and configure communication blackout periods',
    saveAlertTemplates: 'Save Templates',
    languageLabel: 'System Language',
    languageDesc: 'Select your preferred console interface language',
    back: 'Back',
    phoneOrEmailRequired: 'Phone or email is required',
    passwordRequired: 'Password is required',
    passwordMismatch: 'Confirm password does not match new password',
    passwordUpdatedSuccess: 'Password updated successfully! Please log in with your new password.',
    failedToSendCode: 'Failed to send verification code',
    failedToResetPassword: 'Failed to reset password',
    loginFailed: 'Login failed',

    geocodingBoundsHeader: 'Geocoding Bounding Limits',
    geocodingBoundsDesc: 'Restrict Nominatim address searches strictly to your local county or state to prevent global coordinate conflicts',
    geocodingBoundsExplanation: 'Entering geocoding bounds locks Nominatim search queries to the specified lat/lon boundary coordinates. Addresses found outside these bounds will be filtered to avoid accidental lookups in another state.',
    minLatLabel: 'Minimum Latitude (South Limit)',
    maxLatLabel: 'Maximum Latitude (North Limit)',
    minLonLabel: 'Minimum Longitude (West Limit)',
    maxLonLabel: 'Maximum Longitude (East Limit)',
    saveGeocodingBounds: 'Save Geocoding Bounds',
    savingBounds: 'Saving bounds...',
    
    preStormHeader: '1. Pre-Storm Warning Template',
    enRouteHeader: '2. Crew En-Route Template',
    completedHeader: '3. Completion Proof Template',
    overdueEmailHeader: '4. Overdue Account Invoice Email Template',
    overdueEmailDesc: 'Design a premium, responsive HTML email notice to alert clients with overdue balances. Double-bracket tags will be dynamically replaced when reminding customers.',
    injectTagsLabel: 'Inject Tags:',
    livePreviewLabel: 'Live Render HTML Sandbox Preview',
    expandPreviewBtn: 'Expand Live Preview',
    collapsePreviewBtn: 'Collapse Preview',
    quietHoursBufferHeader: 'Quiet Hours Message Buffer',
    quietHoursBufferDesc: 'When active, all automated pre-storm and completion SMS notifications generated inside the quiet hour window are held in a postponed Bull queue and dispatched automatically at the end of quiet hours.',
    quietHoursStartLabel: 'Quiet Period Begins',
    quietHoursEndLabel: 'Quiet Period Concludes',
    saveAlertsBtn: 'Save Alerts & Quiet Hours',
    savingAlerts: 'Saving changes...',

    failedToLoadSettings: 'Failed to load settings data',
    orgSettingsUpdated: 'Organization settings updated successfully',
    failedToSaveSettings: 'Failed to save settings',
    profileUpdated: 'Account profile updated successfully',
    failedToUpdateProfile: 'Failed to update profile',
    passwordUpdated: 'Password updated successfully',
    passwordUpdateFailed: 'Password update failed',
  },
  'en-US': {
    // English US inherits CA translations except spelling differences
    // (US: color, center, check, favor, realize, program)
  },
  'en-GB': {
    // English UK inherits CA translations except spelling differences
    // (UK: colour, centre, cheque, favour, realise, programme)
  }
};

export const generalDynamicTranslations: Record<string, Record<string, string>> = {
  'fr-QC': {
    // Fleet / Operations
    'Operational Roster': 'Effectif opérationnel',
    'Online': 'En ligne',
    'Offline': 'Hors ligne',
    'Active Runs': 'Trajets actifs',
    'Active': 'Actif',
    'Idle': 'Inactif',
    'Storm Event': 'Tempête',
    'No Active Storm Event': 'Aucune tempête active',
    'B2B Subcontract Exchange': 'Échange de sous-traitance B2B',
    'Active Emergency Plowing Request': 'Demande urgente de déneigement active',
    'Fleet Operations': 'Opérations de la flotte',
    'Search fleet, vehicles...': 'Rechercher flotte, véhicules...',
    'All': 'Tout',
    'No Active Route': 'Aucun trajet actif',
    'stops complete': 'arrêts complétés',
    'shift': 'quart',
    'Red Fatigue Alert': 'Alerte de fatigue rouge',
    'Amber Fatigue Warning': 'Avertissement de fatigue jaune',
    'Play': 'Lire',
    'Pause': 'Pause',
    'Stops List': 'Liste des arrêts',
    'Pending': 'En attente',
    'In Progress': 'En cours',
    'Completed': 'Complété',
    'Skipped': 'Sauté',
    'No active route assigned to driver': 'Aucun trajet actif assigné au chauffeur',
    'No active storm telemetry': 'Aucune télémétrie de tempête active',
    'Listening for GPS broadcasts...': 'Écoute des transmissions GPS...',
    'Proof of Service Photo Verification': 'Vérification de photo de preuve de service',
    'Close': 'Fermer',
    'Liability protection proof of service escrow photo': 'Photo de preuve de service pour protection de responsabilité',
    'View Proof Photo': 'Voir photo de preuve',
    'Telemetry Stream': 'Flux de télémétrie',
    'Latest Coordinates': 'Dernières coordonnées',
    'Current Speed': 'Vitesse actuelle',
    'Last Active Connection': 'Dernière connexion active',
    'High-Priority Dispatch alert': 'Alerte de répartition haute priorité',
    'Send Urgent audio alert': 'Envoyer alerte audio urgente',
    'Render Historical Trail': 'Afficher le trajet historique',
    'Overlays previous driven points on the map': 'Superpose les points conduits précédents sur la carte',
    'Show Trail': 'Afficher trajet',
    'Hide Trail': 'Masquer trajet',
    'Route Playback Mode': 'Mode lecture du trajet',
    'Animate history breadcrumbs sequentially': 'Animer les points historiques séquentiellement',
    'Playback Speed': 'Vitesse de lecture',
    'Retrieving tracking logs from telemetry base...': 'Récupération des journaux de suivi depuis la base...',
    'Service Proof Photo': 'Photo de preuve de service',
    'No stops populated for this route.': 'Aucun arrêt pour ce trajet.',
    'Manual Dispatch Override': 'Contournement manuel de répartition',
    'Force status to complete': 'Forcer le statut à complété',
    'Confirm completion proof': 'Confirmer la preuve de complétion',
    'Emergency Handover Request': 'Demande de transfert d\'urgence',
    'Driver has requested a shift handover.': 'Le chauffeur a demandé un transfert de quart.',
    'Approve Handover': 'Approuver le transfert',
    'Reject Handover': 'Rejeter le transfert',

    // Customers
    'Customer Accounts': 'Comptes clients',
    'Manage servicing properties, geocodes, and service decisions': 'Gérer les propriétés de service, géocodes et décisions de service',
    'Export CSV': 'Exporter CSV',
    'Import CSV': 'Importer CSV',
    'Add Customer': 'Ajouter un client',
    'Search by name, address, or phone...': 'Rechercher par nom, adresse ou téléphone...',
    'All Statuses': 'Tous les statuts',
    'Customer': 'Client',
    'Property info': 'Info propriété',
    'Alerts': 'Alertes',
    'Decision': 'Décision',
    'Sign Status': 'Statut du panneau',
    'Payment Balance': 'Solde de paiement',
    'Status': 'Statut',
    'Actions': 'Actions',
    'Retrieving customer database...': 'Récupération de la base de données clients...',
    'No customers found matching the criteria.': 'Aucun client trouvé correspondant aux critères.',
    'Residential': 'Résidentiel',
    'Commercial': 'Commercial',
    'Installed': 'Installé',
    'Needs Service': 'Besoin de service',
    'Removed': 'Retiré',
    'View Service & Billing History': 'Voir l\'historique de service et facturation',
    'Edit Customer': 'Modifier le client',
    'Delete Customer': 'Supprimer le client',
    'Showing page': 'Affichage de la page',
    'of': 'sur',
    'total': 'au total',
    'Previous': 'Précédent',
    'Next': 'Suivant',
    'Profile Dashboard': 'Tableau de bord de profil',
    'Outstanding Balance': 'Solde impayé',
    'Payment Status': 'Statut du paiement',
    'Sign Inventory': 'Inventaire de panneaux',
    'Servicing History': 'Historique de service',
    'Payment & Billing History': 'Historique de paiement et facturation',
    'Chronological Records': 'Historique chronologique',
    'No logged payment history found.': 'Aucun historique de paiement enregistré.',
    'Record A Payment': 'Enregistrer un paiement',
    'Payment Amount': 'Montant du paiement',
    'Method': 'Méthode',
    'Internal Notes': 'Notes internes',
    'Apply Payment': 'Appliquer le paiement',
    'Modify Customer Profile': 'Modifier le profil du client',
    'Register New Customer Property': 'Enregistrer une nouvelle propriété',
    'Customer name': 'Nom du client',
    'Service address': 'Adresse de service',
    'Verify': 'Vérifier',
    'Verifying...': 'Vérification...',
    'Phone number': 'Numéro de téléphone',
    'Email address': 'Adresse courriel',
    'Driveway type': 'Type d\'entrée',
    'Access notes & gate codes': 'Notes d\'accès et codes de barrière',
    'Send SMS alerts on service': 'Envoyer des alertes SMS lors du service',
    'Send Automated Voice alert calls': 'Envoyer des appels d\'alerte vocale automatisés',
    'Off-season Sign Placement Status': 'Statut de placement du panneau hors saison',
    'Billing Ledger Balance': 'Solde du grand livre de facturation',
    'Cancel': 'Annuler',
    'Save Customer': 'Sauvegarder le client',

    // Drivers
    'Fleet Drivers': 'Chauffeurs de la flotte',
    'Manage driver profiles, shifts, and equipment assignments': 'Gérer les profils de chauffeurs, les quarts et les équipements',
    'Add Driver': 'Ajouter un chauffeur',
    'Search by name, email or phone...': 'Rechercher par nom, courriel ou téléphone...',
    'Driver Name': 'Nom du chauffeur',
    'Vehicle Assigned': 'Véhicule assigné',
    'Hourly Rate': 'Tarif horaire',
    'Current Shift': 'Quart actuel',
    'Sign Out Driver': 'Déconnecter le chauffeur',
    'Edit Driver': 'Modifier le chauffeur',
    'Delete Driver': 'Supprimer le chauffeur',
    'No drivers found.': 'Aucun chauffeur trouvé.',
    'Shift: Active': 'Quart: Actif',
    'Shift: Off': 'Quart: Inactif',
    'Modify Driver Details': 'Modifier les détails du chauffeur',
    'Create Driver Profile': 'Créer un profil de chauffeur',
    'Driver name': 'Nom du chauffeur',
    'Password override': 'Changement de mot de passe',
    'Leave blank to keep existing password': 'Laisser vide pour conserver le mot de passe existant',
    'Vehicle Type / Name': 'Type / nom du véhicule',
    'Hourly Billing Rate': 'Tarif horaire de facturation',
    'Save Driver': 'Sauvegarder le chauffeur',

    // Storms
    'Storm Events Tracker': 'Suivi des tempêtes',
    'Monitor snowfall accumulations, dispatch triggers, and active status': 'Surveiller les accumulations de neige, les déclencheurs de répartition et les statuts actifs',
    'Add Storm': 'Ajouter une tempête',
    'Search by storm name...': 'Rechercher par nom de tempête...',
    'Active Storm': 'Tempête active',
    'Storm Name': 'Nom de la tempête',
    'Date Triggered': 'Date déclenchée',
    'Snow Accumulation': 'Accumulation de neige',
    'Stops Serviced': 'Arrêts servis',
    'Active Status': 'Statut actif',
    'End Storm Event': 'Terminer la tempête',
    'Delete Storm': 'Supprimer la tempête',
    'No storm records found.': 'Aucun enregistrement de tempête trouvé.',
    'Register New Storm Event': 'Enregistrer une nouvelle tempête',
    'Trigger snowfall accumulation event and notify fleet': 'Déclencher une tempête et avertir la flotte',
    'Storm name': 'Nom de la tempête',
    'Current Snow Accumulation (Inches)': 'Accumulation de neige actuelle (pouces)',
    'Mark as Active Event': 'Marquer comme événement actif',
    'Save Storm': 'Sauvegarder la tempête',

    // Routes
    'Service Routes': 'Trajets de service',
    'Plan, assign, and optimize service routes for drivers': 'Planifier, assigner et optimiser les trajets de service',
    'Add Route': 'Ajouter un trajet',
    'Search by route name...': 'Rechercher par nom de trajet...',
    'Route Name': 'Nom du trajet',
    'Assigned Driver': 'Chauffeur assigné',
    'Stops Count': 'Nombre d\'arrêts',
    'Progress': 'Progression',
    'Optimized (TSP)': 'Optimisé (TSP)',
    'Yes': 'Oui',
    'No': 'Non',
    'Optimize TSP': 'Optimiser TSP',
    'Edit Route': 'Modifier le trajet',
    'Delete Route': 'Supprimer le trajet',
    'No routes found.': 'Aucun trajet trouvé.',
    'Create New Service Route': 'Créer un nouveau trajet de service',
    'Modify Service Route': 'Modifier le trajet de service',
    'Route name': 'Nom du trajet',
    'Assign Driver': 'Assigner un chauffeur',
    'Select Driver': 'Sélectionner un chauffeur',
    'Route Stops Selection': 'Sélection des arrêts du trajet',
    'Search customer stops...': 'Rechercher les arrêts clients...',
    'Selected Stops': 'Arrêts sélectionnés',
    'No stops selected yet': 'Aucun arrêt sélectionné pour le moment',
    'Available Customer Properties': 'Propriétés clients disponibles',
    'Save Route': 'Sauvegarder le trajet',

    // Finance
    'Finance & Off-season Signs': 'Finances & Panneaux de hors-saison',
    'Invoices, payments, and sign inventory tracking': 'Factures, paiements et suivi de l\'inventaire des panneaux',
    'Revenue & Invoicing Summary': 'Sommaire des revenus & Facturation',
    'Outstanding Receivables': 'Comptes à recevoir impayés',
    'Total Revenue Collected': 'Revenu total collecté',
    'Estimated Fuel Costs': 'Coûts de carburant estimés',
    'Estimated Driver Payroll': 'Masse salariale estimée des chauffeurs',
    'Projected Net Profit': 'Bénéfice net projeté',
    'Passes Serviced': 'Passes servies',
    'Sign Inventory Tracker': 'Suivi de l\'inventaire des panneaux',
    'Total Signs Installed': 'Total des panneaux installés',
    'Needs Maintenance': 'Besoin d\'entretien',
    'Billing Ledger & Invoices': 'Grand livre de facturation & Factures',
    'All Invoices': 'Toutes les factures',
    'Paid Only': 'Payées seulement',
    'Unpaid Only': 'Impayées seulement',
    'Overdue Only': 'En retard seulement',
    'Invoice ID': 'ID facture',
    'Date Generated': 'Date générée',
    'Outstanding': 'Impayé',
    'Payment Method': 'Méthode de paiement',
    'Send Overdue Email Alert': 'Envoyer alerte courriel de retard',
    'Sending...': 'Envoi...',
    'Email Sent': 'Courriel envoyé',
    'Paid': 'Payé',
    'Overdue': 'En retard',

    // Analytics
    'Business Intelligence & KPIs': 'Rapports d\'affaires & KPIs',
    'Storm statistics, financial margins, and operations analytics': 'Statistiques de tempête, marges financières et analyses opérationnelles',
    'Storm Efficiency Metrics': 'Mesures d\'efficacité de tempête',
    'Average Completion Speed': 'Vitesse moyenne de complétion',
    'stops/hour': 'arrêts/heure',
    'Stops Completion Rate': 'Taux de complétion des arrêts',
    'Estimated Operating Margin': 'Marge opérationnelle estimée',
    'Active Drivers on Duty': 'Chauffeurs actifs en service',
    'Serviced Stops Analysis': 'Analyse des arrêts servis',
    'Hourly Telemetry Completion Rate': 'Taux de complétion de télémétrie horaire',
    'Storm Financial Performance': 'Performance financière de la tempête',
    'Route Dispatch Analysis': 'Analyse de répartition des trajets',
    'Stops Completed': 'Arrêts complétés',
    'Stops Skipped': 'Arrêts sautés',
'Stops Pending': 'Arrêts en attente',
    'Planned & Archived Events': 'Événements planifiés & archivés',
    'Expected time frame': 'Période prévue',
    'Plow Passes': 'Passes de déneigement',
    'Actual accumulation': 'Accumulation réelle',
    'Event details': 'Détails de l\'événement',
    'Plan Storm Event': 'Planifier la tempête',
    'Archive Storm Event': 'Archiver la tempête',
    'Storm Passes': 'Passes de tempête',
    'Actual Recorded Accumulation': 'Accumulation réelle enregistrée',
    'Record & Close Storm': 'Enregistrer & fermer la tempête',
    'Expected Start Time': 'Heure de début prévue',
    'Expected End Time': 'Heure de fin prévue',
    'Forecast (inches)': 'Prévision (pouces)',
    'Storm Name / Code': 'Nom / Code de la tempête',
    'No storm events listed. Click "Plan Storm Event" to initialize.': 'Aucun événement répertorié. Cliquer sur "Planifier la tempête" pour commencer.',
    'Forecast': 'Prévision',
    'Passes': 'Passes',
    'Complete Storm': 'Terminer la tempête',
    'PLANNED': 'PLANIFIÉ',
    'ARCHIVED': 'ARCHIVÉ',
    'CANCELLED': 'ANNULÉ',
    'ACTIVE STORM': 'TEMPÊTE ACTIVE',
    'Storm Operations Control': 'Suivi des tempêtes',
    'Register storm accumulation forecasts, trigger active dispatching, and record actual event totals': 'Gérer les prévisions d\'accumulation, déclencher la répartition et enregistrer les résultats',
    'Meteorology Live Alert': 'Alerte météo en direct',
    'Wind': 'Vent',
    'Visibility': 'Visibilité',
    'Audio dispatch alert transmitted successfully!': 'Alerte de répartition audio transmise avec succès!',
    'Failed to dispatch alert': 'Échec de l\'envoi de l\'alerte',
    'Finance & Signs Console': 'Console de finances & panneaux',
    'Monitor outstanding balances, invoice tracking, and winter placements': 'Suivre les soldes impayés, le suivi des factures et les placements d\'hiver',
    'Sync Roster': 'Synchroniser la liste',
    'Gross Outstanding A/R': 'Comptes clients en souffrance bruts',
    'Overdue Accounts': 'Comptes en retard',
    'Signs Installed': 'Panneaux installés',
    'Installation Progress': 'Progression de l\'installation',
    'Accounts Receivable Console': 'Console des comptes clients',
    'Collect balances & export billing alert summaries': 'Percevoir les soldes & exporter les résumés d\'alertes de facturation',
    'Export A/R': 'Exporter les comptes clients',
    'Processing financial roster...': 'Traitement de la liste financière...',
    'Good job! Zero accounts are currently overdue.': 'Beau travail! Aucun compte n\'est actuellement en retard.',
    'Balance due': 'Solde dû',
    'Sign Crew Route Planner': 'Planificateur de trajet de l\'équipe des panneaux',
    'Generate optimized sign placement and transition paths': 'Générer les emplacements de panneaux optimisés et les chemins de transition',
    'Install Signs': 'Installer les panneaux',
    'Remove Signs': 'Retirer les panneaux',
    'Running TSP optimization algorithms...': 'Exécution des algorithmes d\'optimisation TSP...',
    'Zero sign tasks currently required.': 'Aucune tâche de panneau requise pour le moment.',
    'All active customers have already completed their seasonal placements!': 'Tous les clients actifs ont déjà complété leurs placements de saison!',
    'Route Metrics': 'Mesures du trajet',
    'No stops in this optimized path.': 'Aucun arrêt dans ce chemin optimisé.',
    'Mailing Balance Due Reminder Template': 'Modèle de lettre de rappel de solde dû',
    'Close View': 'Fermer la vue',
    'Close Preview': 'Fermer l\'aperçu',
    'Print Letter': 'Imprimer la lettre',
    'Send Email Reminder': 'Envoyer le rappel par courriel',
    'This customer has no registered email address': 'Ce client n\'a pas d\'adresse courriel enregistrée',
    'Send overdue notice directly via email': 'Envoyer l\'avis de retard directement par courriel',
    'Optimized install route generated successfully!': 'Trajet d\'installation optimisé généré avec succès!',
    'Optimized remove route generated successfully!': 'Trajet de retrait optimisé généré avec succès!',
    'Failed to optimize sign crew route': 'Échec de l\'optimisation du trajet de l\'équipe des panneaux',
    'No accounts currently require balances reminder': 'Aucun compte ne nécessite de rappel de solde actuellement',
    'Payment reminder successfully emailed to': 'Rappel de paiement envoyé avec succès par courriel à',
    'Failed to send payment reminder email': 'Échec de l\'envoi du courriel de rappel de paiement',
    'Failed to retrieve financial parameters': 'Échec de la récupération des paramètres financiers',
    'properties': 'propriétés',
    'property': 'propriété',
    'installed': 'installé',

    // New LiveOps / General keys
    'Notifying nearest driver': 'Notification du chauffeur le plus proche',
    'crew': 'l\'équipe',
    'miles away': 'milles plus loin',
    'Attempt': 'Tentative',
    'Escalation Timer Active': 'Minuteur d\'escalade actif',
    'Minutes': 'Minutes',
    'Refreshes fleet connections': 'Actualise les connexions de la flotte',
    'No matches found in operational database.': 'Aucune correspondance trouvée dans la base opérationnelle.',
    'Stops progress…': 'Progression des arrêts…',
    'Commercial Plow': 'Charrue commerciale',
    'Vis': 'Vis.',
    'Plow Vehicle': 'Véhicule de déneigement',
    'No phone': 'Pas de téléphone',
    'hr rate': 'tarif/h',
    'Stationary': 'À l\'arrêt',
    'Offline. Listening for GPS signals...': 'Hors ligne. Écoute des signaux GPS...',
    'Blocked exit, divert to Stop #4...': 'Sortie bloquée, dévier vers l\'arrêt #4...',
    'Dispatched...': 'Envoyé...',
    'Deactivate': 'Désactiver',
    'Activate': 'Activer',
    'Frame': 'Trame',
    'No drivers are active in the current storm event. Once vehicles start their routes and broadcast GPS updates, they will appear on the live tracking console.': 'Aucun chauffeur n\'est actif dans la tempête en cours. Dès que les véhicules commenceront leurs trajets et diffuseront des mises à jour GPS, ils apparaîtront sur la console.',
    'Liability protection proof of service escrow photo · Verified Clear': 'Photo de preuve de service pour protection de responsabilité · Vérifiée et approuvée',
    
    // New Customer keys
    'No email': 'Pas de courriel',
    'No email on file — click Edit to add one': 'Aucun courriel au dossier — clique sur Modifier pour en ajouter un',
    'Export Roster as CSV': 'Exporter la liste en CSV',
    'Import Roster via CSV': 'Importer la liste via CSV',
    'paid': 'payé',
    'pending': 'en attente',
    'overdue': 'en retard',
    'prospect': 'prospect',
    'active': 'actif',
    'inactive': 'inactif',
    'removed': 'retiré',
    'needs_service': 'besoin d\'entretien',
    'Pass': 'Passe',
    'Driver': 'Chauffeur',
    'Route': 'Trajet',
    'Date': 'Date',
    'Cleared': 'Complété',
    'Cash / Handheld': 'Espèces / En main',
    'Check': 'Chèque',
    'Credit Card': 'Carte de crédit',
    'ACH Transfer': 'Virement ACH',
    'Other Method': 'Autre méthode',
    'Log reference number...': 'Entrer le numéro de référence...',
    'Processing...': 'Traitement...',
    'e.g. John Doe, Buffalo Mall': 'ex. John Doe, Centre d\'achats',
    'e.g. 125 Main St, Buffalo NY': 'ex. 125 rue Principale, Montréal QC',
    '555-0199': '555-0199',
    'john@example.com': 'jean@exemple.com',
    'Balance': 'Solde',
    '0.00': '0,00',
    'Optional': 'Optionnel',
    'e.g. 2-car asphalt, gravel, steep slope': 'ex. asphalte 2 voitures, gravier, pente abrupte',
    'Gate code 4082, beware of dog on back lot': 'Code barrière 4082, attention au chien dans la cour',
    'Latitude': 'Latitude',
    'Longitude': 'Longitude',
    'Matched': 'Trouvé',
    'Update Profile': 'Mettre à jour le profil',
    'Register Customer': 'Enregistrer le client',
    'Bulk Import Customer Roster': 'Importation en lot de la liste des clients',
    'Copy and paste raw comma-separated CSV text directly. Missing coordinates are geocoded automatically with 1.1s sequential query pacing to Nominatim.': 'Copie et colle directement le texte CSV brut séparé par des virgules. Les coordonnées manquantes sont géocodées automatiquement avec un délai de 1,1 s pour Nominatim.',
    'Headers': 'En-têtes',
    'Example': 'Exemple',
    'Name, Address, Phone, Email, Property Type, Outstanding Balance, Sign Status': 'Nom, Adresse, Téléphone, Courriel, Type de propriété, Solde impayé, Statut du panneau',
    'Name,Address,Phone,Email,Property Type,Outstanding Balance,Sign Status...': 'Nom,Adresse,Téléphone,Courriel,Type de propriété,Solde,Statut du panneau...',
    'Submit Roster': 'Soumettre la liste',
    'Soft-Delete Customer?': 'Supprimer temporairement le client?',
    'This will mark the customer as deleted. They will no longer be included in storm routing lists, but historical routes and GPS logs will remain intact.': 'Cela marquera le client comme supprimé. Il ne sera plus inclus dans les trajets de tempête, mais l\'historique des trajets et des journaux GPS sera conservé.',
    'Keep Active': 'Garder actif',
    'Delete Profile': 'Supprimer le profil',
    'Payment recorded successfully': 'Paiement enregistré avec succès',
    'Failed to log payment': 'Échec de l\'enregistrement du paiement',
    'Failed to export CSV': 'Échec de l\'exportation du CSV',
    'Successfully imported {{count}} customers! Errors: {{errors}}': 'Importation réussie de {{count}} clients! Erreurs: {{errors}}',
    'Failed to import CSV': 'Échec de l\'importation du CSV',
    'Logged Payment': 'Paiement enregistré',
    'Querying customer logs...': 'Recherche des journaux clients...',
    'No historical service logs found for this customer.': 'Aucun historique de service trouvé pour ce client.',

    // Landing Page
    'Smart Dispatch Platform': 'Plateforme de répartition intelligente',
    'Access Console': 'Accéder à la console',
    'Next-Generation Snow Operations for Winter 2026': 'Opérations de déneigement de nouvelle génération pour l\'hiver 2026',
    'Commercial Snow Plow': 'Déneigement commercial',
    'Dispatch & Live Tracking': 'Répartition et suivi en direct',
    'Optimize route dispatches, track plow fleets in real time with high-precision telemetry, and provide homeowners with instant SMS updates and photo proof of service.': 'Optimisez la répartition des trajets, suivez la flotte de déneigement en temps réel avec une télémétrie de haute précision, et fournissez aux propriétaires des mises à jour SMS instantanées.',
    'Access Dispatch Console': 'Accéder à la console de répartition',
    'Get Driver App': 'Télécharger l\'application chauffeur',
    'PlowPath Operations Control': 'Contrôle des opérations de PlowPath',
    'Live Ops Geolocation Map': 'Carte de géolocalisation Live Ops',
    'Interactive real-time map plotting active plow trucks, path trails, status markers, and current weather layers across service zones.': 'Carte interactive en temps réel affichant les camions de déneigement actifs, les trajets parcourus, les marqueurs de statut et les couches météo.',
    'Smart Route Optimization': 'Optimisation intelligente des trajets',
    'Automatically sequence and group client properties into logical dispatch routes. Minimize deadhead transit time during blizzards.': 'Séquencez et regroupez automatiquement les propriétés des clients dans des trajets logiques. Minimisez le temps de transit inutile pendant les tempêtes.',
    'Automated Client Alerts': 'Alertes clients automatisées',
    'Keep homeowners informed by sending automatic SMS updates with ETA predictions, en-route status, and clearance completion notices.': 'Gardez les propriétaires informés en envoyant des SMS automatiques avec des prévisions d\'ETA, l\'état en route et des avis de complétion.',
    'Full Suite of Winter Management Tools': 'Gamme complète d\'outils de gestion hivernale',
    'Everything your operations team needs to run heavy-duty dispatching, monitor driver telemetry, and keep clients satisfied.': 'Tout ce dont votre équipe a besoin pour gérer la répartition, suivre la télémétrie des chauffeurs et satisfaire les clients.',
    'Storm Management': 'Gestion des tempêtes',
    'Define active snowstorms, spin up dispatch cycles, and track the progress percentage of clearing properties throughout the event.': 'Définissez les tempêtes actives, lancez des cycles de répartition et suivez le pourcentage de progression du déneigement.',
    'Driver & Customer Portals': 'Portails des chauffeurs et clients',
    'Unified database managing driver credentials, payroll metrics, client subscription profiles, and specific driveway clear instructions.': 'Base de données unifiée gérant les informations des chauffeurs, la paie, les profils d\'abonnement des clients et les instructions d\'accès.',
    'Analytics & Business Intelligence': 'Analyses & intelligence d\'affaires',
    'Review driver speeds, time spent per clear site, weather duration logs, and customer billing statements under a single window.': 'Analysez la vitesse des chauffeurs, le temps passé par site, les journaux de tempête et la facturation sous une seule fenêtre.',
    'Homeowner Tracking': 'Suivi pour les propriétaires',
    'Send secure tracking links to homeowners showing their assigned plow\'s ETA, live progress map, and clearance completion report.': 'Envoyez des liens de suivi sécurisés aux propriétaires indiquant l\'ETA du chasse-neige, la carte de progression en direct et le rapport de complétion.',
    'Background Geolocation': 'Géolocalisation en arrière-plan',
    'Driver telemetry uploads in the background via robust native service modules. No lost location data when driver screens are locked.': 'La télémétrie des chauffeurs se télécharge en arrière-plan via des modules natifs robustes. Aucune perte de position lorsque l\'écran est verrouillé.',
    'Enterprise Grade Security': 'Sécurité de niveau entreprise',
    'Secure database logs, dispatch roles, encrypted password hashing, and tokenized session APIs keep corporate telemetry secure.': 'Les journaux sécurisés, les rôles de répartition, le hachage des mots de passe et les sessions d\'API protègent votre télémétrie corporative.',
    'Interactive Profitability Simulator': 'Simulateur interactif de rentabilité',
    'Calculate Your Cost & Return on Investment': 'Calculez votre coût et retour sur investissement',
    'See exactly how our serverless, pay-as-you-go infrastructure performs under heavy winter workloads, and verify the ROI for your business.': 'Voyez exactement comment notre infrastructure à la carte réagit sous les lourdes charges hivernales et vérifiez le ROI de votre entreprise.',
    'Interactive Parameters': 'Paramètres interactifs',
    'Number of Active Clients': 'Nombre de clients actifs',
    'Count of driveways, lanes, and commercial lots serviced.': 'Nombre d\'entrées, de chemins et de terrains commerciaux desservis.',
    'Active Drivers / Tractors': 'Chauffeurs / Tracteurs actifs',
    'drivers': 'chauffeurs',
    'Drivers running the PlowPath mobile app in their cabs.': 'Chauffeurs exécutant l\'application PlowPath dans leur cabine.',
    'Average Storms per Month': 'Moyenne de tempêtes par mois',
    'winter events': 'événements hivernaux',
    'Weather events prompting client alert dispatches and tracking.': 'Événements météo déclenchant des dispatches d\'alerte et le suivi.',
    'Avg. Seasonal Contract Value': 'Valeur contractuelle saisonnière moy.',
    'season': 'saison',
    'Average amount billed to each client property per season.': 'Montant moyen facturé par propriété cliente par saison.',
    'SMS Preference': 'Préférence SMS',
    'Voice Preference': 'Préférence vocale',
    'Production Hosting Tier': 'Hébergement en production',
    'Toggle Staging ($8.25 fixed) vs Production ($41.14 fixed)': 'Basculez entre Staging (8,25 $ fixe) et Production (41,14 $ fixe)',
    'Production Mode': 'Mode production',
    'Staging Mode': 'Mode staging',
    'Calculated Monthly Expenses': 'Frais mensuels calculés',
    'Platform Idle Fixed Cost': 'Frais fixes de plateforme (inactif)',
    'Twilio SMS Alerts (3 msg/storm)': 'Alertes SMS Twilio (3 msg/tempête)',
    'Twilio Voice Confirmations (1.5 min/storm)': 'Confirmations vocales Twilio (1,5 min/tempête)',
    'Upstash Redis Database (Pay-as-you-go)': 'Base de données Upstash Redis (à la carte)',
    'ESTIMATED HEAVY WINTER MONTH BILL': 'FACTURE MENSUELLE ESTIMÉE EN TEMPS DE TEMPÊTE',
    'mo': 'mois',
    'Small Operator Seasonal Value Pitch': 'Argument de valeur saisonnière pour petit opérateur',
    'PlowPath isn\'t a luxury—it\'s an operational necessity designed to expand contract capacity for small operators running **1 to 5 tractors**.': 'PlowPath n\'est pas un luxe, c\'est une nécessité opérationnelle pour augmenter la capacité de contrat des petits opérateurs avec **1 à 5 tracteurs**.',
    'Estimated App Cost': 'Coût estimé de l\'application',
    'yr': 'an',
    '(4 months use + 8 months retention @ $25/mo)': '(4 mois d\'utilisation + 8 mois de rétention à 25 $/mois)',
    'App Cost % of Revenue': 'Coût de l\'application en % du revenu',
    'ofSeasonalContract': 'de',
    'seasonal revenue': 'revenu saisonnier',
    'Capacity Expansion Return (15% Efficiency Increase)': 'Retour d\'expansion de capacité (hausse d\'efficacité de 15 %)',
    'By saving time on route dispatching and using live GPS tracking, you can comfortably clear **15 more properties per driver** this season:': 'En sauvant du temps sur la répartition des trajets et le suivi GPS, vous pouvez facilement déneiger **15 propriétés de plus par chauffeur** :',
    'Additional Contract Revenue:': 'Revenu contractuel additionnel :',
    'NET GAIN (Additional Rev - App Cost):': 'GAIN NET (Revenu additionnel - Coût appli) :',
    'Driver Companion Mobile App': 'Application mobile compagnon du chauffeur',
    'Built for Heavy-Duty Drivers': 'Conçue pour les chauffeurs',
    'Snow plowing requires focus and speed. The PlowPath Driver mobile app provides a high-contrast, simple interface optimized for cold steering wheels.': 'Le déneigement demande de la concentration et de la vitesse. L\'application PlowPath Driver offre une interface simple à haut contraste optimisée pour les mains froides.',
    'Sequenced route list with integrated tap-to-navigate.': 'Liste de trajets séquencés avec navigation intégrée en un clic.',
    'Full offline caching support for route lists and GPS queues.': 'Support complet de cache hors ligne pour les trajets et files GPS.',
    'Stops telemetry collection automatically when off duty.': 'Arrête automatiquement la télémétrie hors service.',
    '* Proof of service photo validation is available as an Enterprise-tier feature for municipal and corporate contracts.': '* La preuve de service photo est disponible en tant que fonctionnalité entreprise pour les contrats municipaux.',
    'Available Platforms': 'Plateformes disponibles',
    'Download For': 'Télécharger pour',
    'Android (Google Play)': 'Android (Google Play)',
    'iOS (App Store)': 'iOS (App Store)',
    'Route Active': 'Trajet actif',
    'Duty On': 'En service',
    'Next Stop': 'Prochain arrêt',
    'Instructions: Clean driveway fully. Pile snow on left lawn side.': 'Instructions : Déneiger l\'entrée au complet. Pile de neige sur le gazon à gauche.',
    'Ready to begin': 'Prêt à commencer',
    'Start Clear': 'Débuter',
    'PlowPath Driver': 'PlowPath Chauffeur',
    'Frequently Asked Questions': 'Foire aux questions (FAQ)',
    'Quick answers to standard operational questions.': 'Réponses rapides aux questions opérationnelles courantes.',
    'How does PlowPath track snowplow trucks?': 'Comment PlowPath suit-il les camions de déneigement?',
    'PlowPath uses a native background telemetry module on the driver\'s phone. This tracking records GPS location update points and velocity details even when the application is minimized or screens are locked. This data compiles straight into the dispatcher\'s Live Ops Dashboard.': 'PlowPath utilise un module de télémétrie natif en arrière-plan. Il enregistre la position GPS et la vitesse même si l\'application est fermée ou le téléphone verrouillé, envoyée en direct à la console.',
    'Can homeowners track progress without an account?': 'Les propriétaires peuvent-ils suivre le déneigement sans compte?',
    'Yes. When a route begins, dispatchers can set PlowPath to dispatch secure, encrypted tracking portal links via SMS. Homeowners click these links to view active plow locations, ETA predictions, and proof of clearance photos.': 'Oui. Au début du trajet, PlowPath peut envoyer un lien de suivi sécurisé par SMS. Les clients cliquent sur ce lien pour voir l\'emplacement en direct du chasse-neige et l\'ETA.',
    'Is location telemetry tracked outside of active shifts?': 'La télémétrie de localisation est-elle suivie hors service?',
    'Absolutely not. Telemetry logs only upload when a driver explicitly taps \'Go On Duty\' and ends immediately when they log out or switch off-duty. We maintain strict compliance with mobile application store privacy guidelines.': 'Absolument pas. Les données se transmettent seulement quand le chauffeur appuie sur "En service" et s\'arrêtent immédiatement quand il se déconnecte.',
    'How is my profile data stored and can I request deletion?': 'Comment mes données sont-elles stockées et puis-je demander leur suppression?',
    'All driver profiles and associated GPS telemetry coordinates are stored on secure cloud databases. You can submit a deletion request at any time using our data deletion request form to permanently purge all data associated with your driver account.': 'Les données sont stockées sur des bases cloud sécurisées. Vous pouvez demander la suppression complète de vos données à tout moment via notre formulaire en ligne.',
    'Enterprise dispatch and telemetry platforms for commercial winter operations.': 'Plateforme de répartition et télémétrie d\'entreprise pour opérations hivernales.',
    'Dispatcher Login': 'Connexion répartiteur',
    'Driver Downloads': 'Téléchargement chauffeur',
    'Support & Privacy': 'Support & Confidentialité',
    'Privacy Policy': 'Politique de confidentialité',
    'Terms of Service': 'Conditions d\'utilisation',
    'Request Data Deletion': 'Demande de suppression de données',
    'Contact': 'Contact',
    '© {{year}} PlowPath Operations Inc. All Rights Reserved.': '© {{year}} PlowPath Operations Inc. Tous droits réservés.',
  }
};

export function getTranslation(locale: Locale, key: string, variables?: Record<string, string | number>): string {
  let dict = translations[locale] as any;
  if (!dict || !dict[key]) {
    const dynDict = generalDynamicTranslations[locale];
    if (dynDict && dynDict[key]) {
      dict = dynDict;
    } else {
      if (locale.startsWith('en')) {
        dict = translations['en-CA'] as any;
      } else {
        dict = translations['fr-QC'] as any;
      }
    }
  }

  let text = dict[key] || (generalDynamicTranslations[locale] && generalDynamicTranslations[locale][key]) || (translations['en-CA'] as any)[key] || key;

  // Apply US/UK spelling variations dynamically if needed
  if (locale === 'en-US') {
    text = text
      .replace(/colour/g, 'color')
      .replace(/Colour/g, 'Color')
      .replace(/centre/g, 'center')
      .replace(/Centre/g, 'Center')
      .replace(/cheque/g, 'check')
      .replace(/favour/g, 'favor')
      .replace(/realise/g, 'realize')
      .replace(/programme/g, 'program');
  } else if (locale === 'en-GB') {
    text = text
      .replace(/color/g, 'colour')
      .replace(/Color/g, 'Colour')
      .replace(/center/g, 'centre')
      .replace(/Center/g, 'Centre')
      .replace(/check/g, 'cheque')
      .replace(/favor/g, 'favour')
      .replace(/realize/g, 'realise')
      .replace(/program/g, 'programme');
  }

  if (variables) {
    Object.keys(variables).forEach((v) => {
      text = text.replace(new RegExp(`{{${v}}}`, 'g'), String(variables[v]));
    });
  }

  return text;
}

export function useTranslation() {
  const language = useSettingsStore((s) => s.language) || 'fr-QC';
  const t = (key: string | keyof typeof translations['fr-QC'], variables?: Record<string, string | number>) => {
    return getTranslation(language, key, variables);
  };

  const formatDate = (date: Date) => {
    if (language === 'fr-QC') {
      const months = [
        'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
        'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
      ];
      return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
    }
    if (language === 'en-CA') {
      // YYYY-MM-DD
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${date.getFullYear()}-${m}-${d}`;
    }
    if (language === 'en-US') {
      // MM/DD/YYYY
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${m}/${d}/${date.getFullYear()}`;
    }
    // en-GB (DD/MM/YYYY)
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${d}/${m}/${date.getFullYear()}`;
  };

  const formatCurrency = (amount: number | string | null | undefined) => {
    const parsed = typeof amount === 'number' ? amount : parseFloat(String(amount || 0));
    const num = isNaN(parsed) ? 0 : parsed;
    if (language === 'fr-QC') {
      return `${num.toFixed(2).replace('.', ',')} $`;
    }
    if (language === 'en-GB') {
      return `£${num.toFixed(2)}`;
    }
    return `$${num.toFixed(2)}`;
  };

  return { t, locale: language, formatDate, formatCurrency };
}
